// extracted by mini-css-extract-plugin
export default {"container":"CustomFormDate_container__VgnUV"};